<header ph-dialog-header>
  <ph-notification-icon [type]="effectiveType()" />
  <h2 ph-notification-title>{{ displayValue().title }}</h2>
  <ph-icon name="cross" width="24px" height="24px" (click)="close()" data-test-hook="notification.close" />
</header>

@if (displayValue().message) {
  <p ph-notification-content>{{ displayValue().message }}</p>
}
@if (displayValue().innerHtml) {
  <p ph-notification-content [innerHTML]="displayValue().innerHtml"></p>
}

@if (notification.actions || actions(); as actions) {
  <div [style.grid-template-columns]="'repeat(' + actions.length + ', 1fr)'" ph-dialog-actions>
    @for (action of actions; track action) {
      @if (action?.text) {
        @if (action.act; as actFn) {
          <button
            (click)="act(actFn)"
            state="secondary"
            ui-ph-button
            size="small"
            [borderless]="true"
          >
            {{ action.text }}
          </button>
        } @else {
          <button
            state="secondary"
            ui-ph-button
            size="small"
            [borderless]="true"
          >
            {{ action.text }}
          </button>
        }
      }
    }
  </div>
}
